import { render, staticRenderFns } from "./HeaderLawyer.vue?vue&type=template&id=023ced73&"
import script from "./HeaderLawyer.vue?vue&type=script&lang=js&"
export * from "./HeaderLawyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports